import React, { useState, useCallback, Dispatch, SetStateAction } from "react";
import "./css/index.css";
import EdiHeader from "./components/EdiHeader";
import Screen from "./components/Screen";
import Popup from "./components/Popup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

type Props = {
  type: "project" | "meetup" | "notice";
  Insert: (e: any) => void;
  fixData: string | undefined;
  status: "new" | "fix";
  Save: ((e: string | undefined) => void) | undefined;
  setIsLook?: Dispatch<SetStateAction<boolean>>;
  SaveTemplate?: (e: string) => void;
};

/** 에디터 */
function Editor({
  type,
  Insert,
  fixData,
  status,
  Save,
  setIsLook,
  SaveTemplate,
}: Props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isUp, setIsUp] = useState({
    status: false,
    type: "",
  });
  const __uploadFile = useCallback((data: string) => {
    return new Promise((resolve, reject) => {});
  }, []);
  const __insetData = useCallback(() => {
    const template = document.getElementById("screen");
    if (template) {
      Insert(template.innerHTML);
    }
  }, [__uploadFile, dispatch, Insert]);

  return (
    <>
      <div className="editor">
        <div className="editor-wrapper">
          <EdiHeader
            setIsUp={setIsUp}
            navigate={navigate}
            type={type}
            __insert={__insetData}
            status={status}
            Save={Save}
            dispatch={dispatch}
            setIsLook={setIsLook}
            SaveTemplate={SaveTemplate}
          />
          <Screen fixData={fixData} SaveTemplate={SaveTemplate} />
        </div>
        <Popup isUp={isUp} setIsUp={setIsUp} />
      </div>
    </>
  );
}

export default Editor;
